import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderDetailsRoutingModule } from './order-details-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { OrderDetailsComponent } from './order-details/order-details.component';
import { OrderDetailsHeaderComponent } from './order-details-header/order-details-header.component';
import { OrderDetailsNavbarComponent } from './order-details-navbar/order-details-navbar.component';
import { OrderDetailsGeneralComponent } from './order-details-general/order-details-general.component';
import { OrderDetailsInstallmentsComponent } from './order-details-installments/order-details-installments.component';
import { OrderDetailsDecidoComponent } from './order-details-decido/order-details-decido.component';
import { OrderDetailsQineticComponent } from './order-details-qinetic/order-details-qinetic.component';
import { OrderDetailsEventsComponent } from './order-details-events/order-details-events.component';
import { OrderDetailsGeneralInfoComponent } from './order-details-general-info/order-details-general-info.component';
import { OrderDetailsGeneralPaymentComponent } from './order-details-general-payment/order-details-general-payment.component';
import { OrderDetailsGeneralTaxDeductionComponent } from './order-details-general-tax-deduction/order-details-general-tax-deduction.component';
import { OrderDetailsGeneralCompanyComponent } from './order-details-general-company/order-details-general-company.component';
import { OrderDetailsGeneralBuyerComponent } from './order-details-general-buyer/order-details-general-buyer.component';
import { OrderDetailsInstallmentsInfoComponent } from './order-details-installments-info/order-details-installments-info.component';
import { OrderDetailsInstallmentsUnpaidsComponent } from './order-details-installments-unpaids/order-details-installments-unpaids.component';
import { OrderDetailsDecidoBd1Component } from './order-details-decido-bd1/order-details-decido-bd1.component';
import { OrderDetailsDecidoBd2Component } from './order-details-decido-bd2/order-details-decido-bd2.component';
import { OrderDetailsDecidoBd5Component } from './order-details-decido-bd5/order-details-decido-bd5.component';
import { OrderDetailsDecidoInfoComponent } from './order-details-decido-info/order-details-decido-info.component';
import { OrderDetailsQineticPositionComponent } from './order-details-qinetic-position/order-details-qinetic-position.component';
import { OrderDetailsQineticDocsComponent } from './order-details-qinetic-docs/order-details-qinetic-docs.component';
import { OrderDetailsQineticRefundComponent } from './order-details-qinetic-refund/order-details-qinetic-refund.component';
import { OrderDetailsQineticInfoComponent } from './order-details-qinetic-info/order-details-qinetic-info.component';
import { OrderDetailsEventsInfoComponent } from './order-details-events-info/order-details-events-info.component';
import { OrderDetailsEventsTimelineComponent } from './order-details-events-timeline/order-details-events-timeline.component';
import { OrderDetailsNoteDialogComponent } from './order-details-note-dialog/order-details-note-dialog.component';
import { OrderDetailsLookedAtDialogComponent } from './order-details-looked-at-dialog/order-details-looked-at-dialog.component';

@NgModule({
  declarations: [
    OrderDetailsComponent,
    OrderDetailsHeaderComponent,
    OrderDetailsNavbarComponent,
    OrderDetailsGeneralComponent,
    OrderDetailsInstallmentsComponent,
    OrderDetailsDecidoComponent,
    OrderDetailsQineticComponent,
    OrderDetailsEventsComponent,
    OrderDetailsGeneralInfoComponent,
    OrderDetailsGeneralPaymentComponent,
    OrderDetailsGeneralTaxDeductionComponent,
    OrderDetailsGeneralCompanyComponent,
    OrderDetailsGeneralBuyerComponent,
    OrderDetailsInstallmentsInfoComponent,
    OrderDetailsInstallmentsUnpaidsComponent,
    OrderDetailsDecidoBd1Component,
    OrderDetailsDecidoBd2Component,
    OrderDetailsDecidoBd5Component,
    OrderDetailsDecidoInfoComponent,
    OrderDetailsQineticPositionComponent,
    OrderDetailsQineticDocsComponent,
    OrderDetailsQineticRefundComponent,
    OrderDetailsQineticInfoComponent,
    OrderDetailsEventsInfoComponent,
    OrderDetailsEventsTimelineComponent,
    OrderDetailsNoteDialogComponent,
    OrderDetailsLookedAtDialogComponent,
  ],
  imports: [
    CommonModule,
    OrderDetailsRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
})
export class OrderDetailsModule {}
